export default __webpack_public_path__ + "static/img_logo_cicle-3c5a86b6b9be1a57e5a71dee731a0ab0.png";